// What the task panel shows while it is still finding out.
//
// The calendar link under a booking and the cancel button under Patient
// Information both wait on a lookup. On a slow line that is a few seconds
// of nothing, long enough for the office to conclude the feature is
// missing. A quiet line says the panel is still looking.
export type Waiting = 'booking' | 'visits';

export function waitingLine(what: Waiting): string {
  return what === 'booking' ? 'Checking the calendar…' : 'Checking for upcoming visits…';
}
